import { ProductNative } from '../../search-spring/types/types'
import { PRICE_ON_APPLICATION_LABEL, formatDollars, isPriceOnApplication } from '../../helpers/formatMoney'
import { type_GM_STATE } from '../../helpers'

declare var GM_STATE: type_GM_STATE
type Props = {
  product: ProductNative
}
declare var GM_STATE: type_GM_STATE

const CarouselCardNative = ({ product }: Props): JSX.Element | null => {
  if (!product) return null

  const { defaultImage } = GM_STATE.shopify
  const imageUrl = product.featured_image ? product.featured_image : defaultImage
  const hasFromLabel = product.price_max !== product.price_min || product.tags.includes('FROM') || product.tags.includes('from') || product.tags.includes('Template_Same Pair')
  const minPrice =  product.price_max !== product.price_min ? product.price_min : product.price
  const minPriceValue = Number(minPrice)
  const shouldShowPriceOnApplication = isPriceOnApplication(minPriceValue, product.tags)
  const showCompareAtPrice = Number(product.compareAtPriceMin) > minPriceValue && !shouldShowPriceOnApplication
  const currentPriceText = shouldShowPriceOnApplication
    ? PRICE_ON_APPLICATION_LABEL
    : `${hasFromLabel ? 'FROM ' : ''}${formatDollars(minPriceValue / 100)}`
  const rootUrlWithoutSlash = window.routes.rootUrlWithoutSlash
  const productUrl = product.url
  const productUrlWithLocale = !rootUrlWithoutSlash || (rootUrlWithoutSlash && productUrl.includes(rootUrlWithoutSlash))
    ? productUrl
    : rootUrlWithoutSlash + productUrl

  return (
    <div className="relative group">
      <a href={productUrlWithLocale} className="block relative w-full h-auto" title={product.title}>
        <img src={`${imageUrl}&width=1200`} width="auto" height="auto" alt={product.title} className="w-full h-auto object-cover aspect-[170/212] lg:aspect-[335/419]" loading="lazy" />
        {product.images.length > 1 && (
          <img
            src={product.images[1]}
            width="auto"
            height="auto"
            alt={`${product.title} hover`}
            className="w-full h-auto absolute top-0 left-0 opacity-0 group-hover:opacity-100 transition-opacity duration-[350ms] ease-in-out md-max:hidden object-cover aspect-[170/212] lg:aspect-[335/419]"
          />
        )}
      </a>

      <div className="relative flex flex-col">
        <div
          className={`flex flex-col mt-XS transition-opacity duration-[350ms] ease-in-out ${
            product.metafields.productBiLine && product.metafields.productBiLine !== '' ? 'md:group-hover:opacity-0' : ''
          }`}
        >
          <a href={productUrlWithLocale}>
            <h3 className="uppercase font-bstSpyre tracking-[1%] text-[12px] md:text-[14px] leading-[150%] md:leading-[120%] text-base-2">{product.title}</h3>
          </a>
          <div className="mt-XS flex justify-between items-center gap-2.5">
            <div className="flex justify-start gap-1">
              {showCompareAtPrice ? (
                <>
                  <p className="font-calibre uppercase tracking-[4%] text-[12px] leading-[120%] font-light">
                    {currentPriceText}
                  </p>
                  <p className="font-calibre uppercase line-through opacity-40 tracking-[4%] text-[12px] leading-[120%]">
                    {formatDollars(Number(product.compareAtPriceMin) / 100)}
                  </p>
                </>
              ) : (
                <p className="font-calibre uppercase tracking-[4%] text-[12px] leading-[120%] font-light">
                  {currentPriceText}
                </p>
              )}
            </div>
          </div>
        </div>

        {product.metafields.productBiLine !== '' && product.metafields.productBiLine !== null && (
          <div className="absolute top-0 left-0 w-full transition-opacity duration-[350ms] ease-in-out opacity-0 group-hover:opacity-100 md-max:hidden">
            <div className="flex align-baseline justify-between gap-2.5 w-full mt-XS">
              <a href={productUrlWithLocale}>
                <h3 className="font-bstSpyre text-base-2">{product.metafields.productBiLine}</h3>
              </a>
            </div>

            <div className="mt-XS flex justify-start gap-1">
              {showCompareAtPrice ? (
                <>
                  <p className="font-calibre uppercase tracking-[4%] text-[12px] leading-[120%] font-light">
                    {currentPriceText}
                  </p>
                  <p className="font-calibre uppercase line-through opacity-40 tracking-[4%] text-[12px] leading-[120%]">
                    {formatDollars(Number(product.compareAtPriceMin) / 100)}
                  </p>
                </>
              ) : (
                <p className="font-calibre uppercase tracking-[4%] text-[12px] leading-[120%] font-light">
                  {currentPriceText}
                </p>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default CarouselCardNative
